import React from "react";
import { Gavel, FileText, Compass, Scale, ChevronLeft, Check } from "lucide-react";
import { Button } from "../ui/button";
import { INTAKE } from "../../constants/testIds";

const ROUTES = [
  { key: "A", icon: Gavel, title: "I have a court hearing date and need representation." },
  { key: "B", icon: FileText, title: "My court case has started and I need help preparing." },
  { key: "C", icon: Compass, title: "I need guidance before starting a case." },
  { key: "D", icon: Scale, title: "I want to challenge or appeal a judgment or court decision." },
];

export const Stage4RouteSelect = ({ form, set, onBack, onContinue }) => {
  const selected = form.route;
  return (
    <div className="space-y-6">
      <h2 className="font-serif text-3xl text-brand-black">Select the type of help</h2>
      <p className="text-sm text-brand-darkgrey">Which best describes the help you need?</p>

      {selected && (
        <p className="text-sm text-brand-gold" data-testid="route-current-selection">
          Your current selection is highlighted below. Choose a different card to change it.
        </p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {ROUTES.map((r, i) => {
          const Icon = r.icon;
          const active = selected === r.key;
          return (
            <button
              key={r.key}
              type="button"
              onClick={() => { set("route", r.key); window.setTimeout(() => onContinue(), 220); }}
              data-testid={`${INTAKE.routeCard}-${r.key}`}
              aria-pressed={active}
              className={`group relative text-center border p-8 transition-all duration-200 hover:bg-brand-gold hover:border-brand-gold ${
                active ? "bg-brand-gold border-brand-gold ring-2 ring-brand-black ring-offset-2" : "bg-white border-border"
              }`}
            >
              {active && (
                <span
                  className="absolute top-3 right-3 inline-flex items-center gap-1 bg-white text-brand-gold text-xs font-medium px-2 py-0.5 rounded-full"
                  data-testid={`route-card-selected-${r.key}`}
                >
                  <Check className="h-3 w-3" strokeWidth={2.5} /> Selected
                </span>
              )}
              <div className="flex flex-col items-center gap-4">
                <span className={`inline-flex h-12 w-12 items-center justify-center transition-colors duration-200 group-hover:bg-white group-hover:text-brand-gold ${active ? "bg-white text-brand-gold" : "bg-brand-grey text-brand-black"}`}>
                  <Icon className="h-6 w-6" strokeWidth={1.5} />
                </span>
                <p className={`font-serif text-xl md:text-2xl leading-snug transition-colors duration-200 group-hover:text-white ${active ? "text-white" : "text-brand-black"}`}>{r.title}</p>
              </div>
            </button>
          );
        })}
      </div>

      <div className="pt-6 border-t border-border mt-8">
        <Button
          type="button"
          variant="ghost"
          onClick={onBack}
          data-testid={INTAKE.back}
          className="text-brand-darkgrey hover:text-brand-black rounded-sm"
        >
          <ChevronLeft className="h-4 w-4 mr-1" /> Back
        </Button>
      </div>
    </div>
  );
};
